module.exports = __webpack_public_path__ + "img/person-icon.f713251.svg";